exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".attendance-record {\n    /* background-color: #fff; */\n    margin-top: 10px;\n    /* border: 1px solid #ddd;\n    border-radius: 4px;\n    overflow: hidden; */\n  }\n  \n  \n  \n  \n  \n  \n  ", ""]);

